<template lang="pug">
  .payment-edit-form
    .row(v-if="paymentProfileId")
      .card-in-edit.color-slate.xs-f-small.max-at-tweak.mt-10
        .logo(:class="mrClass")
        span(v-if="ccNum") &#42;&#42;&#42;&#42;{{ ccNum }}

    .row(v-else)
      mr-input(label="Card number" v-model="cc_number" @input="checkCard($event)" :v="v.editProfileForm.cc_number" v-mask="editProfileForm.ccMask || '#'" autocomplete="cc-number" dataMrAss="card-number")

    .row
      .xs-6
        dropdown(label="Month" v-model="cc_exp_month" :v="v.editProfileForm.cc_exp_month" required data-mr-ass="expiration-month").pr-5
          option(v-for="m in ccMonths" :value="m.val" :key="m.key" data-mr-ass="month-option") {{ m.key }}

      .xs-6
        dropdown(label="Year" v-model="cc_exp_year" :v="v.editProfileForm.cc_exp_year" required data-mr-ass="expiration-year").pl-5
          option(v-for="y in ccYears" :value="y" :key="y" data-mr-ass="year-option") {{ y }}

    .row(v-if="!paymentProfileId")
      .xs-6
        mr-input(label="Security code" input-type="tel" v-model="cc_cvc" :v="v.editProfileForm.cc_cvc" v-mask="editProfileForm.cvcMask || '#'" autocomplete="cc-csc" dataMrAss="cvv").pr-5
      .xs-2.security-code
        i.icon-info.xs-f-xmedium.max-at-tweak.color-mr-purple(v-tooltip.bottom="cvcTootltip" data-mr-ass="cvv-tool-tip")

    .row.default-billing
      .xs-12
        .checkbox-wrap.mt-5.mb-5
          mr-input-checkbox(v-model="is_default", label="Default payment method" dataMrAss="default-payment-method")

    .row
      h4.bold Billing Address
      .xs-12.same-as-shipping(v-if="defaultShipAddress")
        .checkbox-wrap.mt-5.mb-5
          mr-input-checkbox(v-model="same_as_shipping", label="Same as shipping address" dataMrAss="same-as-shipping-address")

    .row(v-if="defaultShipAddress && same_as_shipping") 
      Address(:address="defaultShipAddress" hide-default=true)

</template>

<script>
  import mask from '../../directives/mask';
  import { mapGetters, mapState, mapMutations } from 'vuex';
  import { paymentProfileClass } from "../../utilities/mrVueUtils";

  import mrInput from '../mrInput';
  import mrInputCheckbox from "../mrInputCheckbox";
  import Address from "../AddressBook/Address";
  import { specialKey } from "../../utilities/mrVueUtils";

  var now = new Date();
  var currYear = now.getFullYear();

  export default {
    name: "PaymentEditForm",
    components: {
      Address,
      mrInput,
      mrInputCheckbox
    },

    directives: {
      mask
    },

    props: ['v'],

    data() {
      return {
        cvcTootltip: {
          placement: 'bottom',
          content: 'This is the last 3 digits printed on the back of your card (Visa, MasterCard, and Discover) or the 4-digit number printed on the front of your card (American Express).',
          class: "vue-tooltip-padded"
        }
      }
    },

    beforeCreate() {
      this.$store.dispatch('subscriptions/initSubscriptions');
    },

    mounted() {
      this.$store.dispatch('payments/testCardNum');
    },

    methods: {
      ...mapMutations('payments', [
        'updateCcNumber',
        'updateExpMonth',
        'updateExpYear',
        'updateCvc',
        'updateIsDefault',
        'updateSameAsShipping',
        'updateUseProfileForAllSubs'
      ]),

      checkCard(event) {
        if (event && specialKey(event)) {
          return;
        }

        this.$store.dispatch('payments/testCardNum');
      }
    },

    computed: {
      ...mapGetters('addressBook', [
        'defaultShipAddress'
      ]),

      ...mapState('payments', [
        'savingProfile',
        'validateProfileForm',
        'editProfileForm'
      ]),


      paymentProfileId() {
        return this.editProfileForm.paymentProfileId;
      },

      ccNum() {
        return this.editProfileForm.ccNum;
      },

      mrClass() {
        return paymentProfileClass(this.editProfileForm.paymentGateway, this.editProfileForm.ccType);
      },

      cc_number: {
        get() {
          return this.editProfileForm.cc_number;
        },

        set(value) {
          this.updateCcNumber(value);
        }
      },

      cc_exp_month: {
        get() {
          return this.editProfileForm.cc_exp_month;
        },

        set(value) {
          this.updateExpMonth(value);
        }
      },

      cc_exp_year: {
        get() {
          return this.editProfileForm.cc_exp_year;
        },

        set(value) {
          this.updateExpYear(value);
        }
      },

      cc_cvc: {
        get() {
          return this.editProfileForm.cc_cvc;
        },

        set(value) {
          this.updateCvc(value);
        }
      },

      is_default: {
        get() {
          return this.editProfileForm.is_default;
        },

        set(value) {
          this.updateIsDefault(value);
        }
      },

      use_payment_for_all_subscriptions: {
        get() {
          return this.editProfileForm.use_payment_for_all_subscriptions;
        },

        set(value) {
          this.updateUseProfileForAllSubs(value);
        }
      },

      same_as_shipping: {
        get() {
          return this.editProfileForm.same_as_shipping;
        },

        set(value) {
          this.updateSameAsShipping(value);
        }
      },

      ccMonths: () => {
        var months = [{ val: '', key: '' }];
        for (var i = 1; i < 13; i++) {
          var m = {};
          m.val = i;
          m.key = i < 10 ? '0' + i : i.toString();
          months.push(m);
        }

        return months;
      },

      ccYears() {
        var years = [' '];
        for (var y = currYear; y < currYear + 20; y++) {
          years.push(y);
        }

        return years;
      }
    }
   }
</script>

<style lang="stylus">

  .payment-edit-form
    .logo
      height 3em
      width 3.62em

    .card-in-edit
      span
        display inline-block
        vertical-align top
        padding-top 1.2em

    .mr-dropdown
      .customDropdown
        width 100% !important

    .default-billing
      margin-bottom 2em

    .same-as-shipping
      margin-top 1em

    .address
      padding-left 2em
      margin-bottom 2.5em

    .address-edit-form
      margin-bottom 2em

    .security-code
      padding-top 1em

  .vue-tooltip
    z-index 300

</style>